import React, { useEffect, useState, useRef } from 'react';
import axios from "axios";

function AdminChat() {
  const [users, setUsers] = useState([]);  // Učitani korisnici s kojima je bilo konverzacija
  const [currentConversation, setCurrentConversation] = useState(null);  // Trenutna aktivna konverzacija
  const [messages, setMessages] = useState([]);  // Poruke trenutne konverzacije
  const [selectedUserId, setSelectedUserId] = useState('');  // ID korisnika koji admin unosi
  const [tempUserId, setTempUserId] = useState('');  // Privremeni unos ID-a korisnika
  const [notifications, setNotifications] = useState({});  // Notifikacije (nepročitane poruke)
  const messagesEndRef = useRef(null);  // Ref za automatsko skrolovanje na kraj poruka
  const chatBoxRef = useRef(null);  // Ref za skrolovanje unutar poruka

  // Učitavanje korisnika s kojima je bilo konverzacija, uključujući broj nepročitanih poruka
  useEffect(() => {
    if (selectedUserId) {
      axios.get(`/api/chat/history/${selectedUserId}`)
        .then(response => {
          setUsers(response.data);  // Postavimo učitane korisnike
          const initialNotifications = {};
          response.data.forEach(user => {
            initialNotifications[user.id_korisnika] = user.unreadCount;  // Povežemo broj nepročitanih poruka sa svakim korisnikom
          });
          setNotifications(initialNotifications);
        })
        .catch(error => console.error('Error fetching users:', error));
    }
  }, [selectedUserId, currentConversation?.id_korisnika]);

  // Formatiranje datuma i vremena za prikaz
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const optionsDate = { day: '2-digit', month: 'short' };  
    const formattedDate = date.toLocaleDateString('en-GB', optionsDate); 

    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false };
    const formattedTime = date.toLocaleTimeString('en-GB', optionsTime);

    return `${formattedDate}, ${formattedTime}`;
  };

  // Skrolovanje na kraj poruka prilikom dodavanja novih poruka
  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages]);

  // Funkcija za odabir korisnika
  const handleUserClick = (user) => {
    setCurrentConversation(user);
    setMessages([]);  // Resetujemo poruke pri promeni korisnika
    axios.get(`/api/chat/messages/conv/${selectedUserId}/${user.id_korisnika}`)
      .then(response => {
        setMessages(response.data);
        // console.log("Messages:", response.data);  // Dodajemo log za provjeru
      })
      .catch(error => console.error('Error fetching messages:', error));
  };

  // Funkcija za promjenu unosa ID-a korisnika
  const handleUserIdChange = (e) => {
    setTempUserId(e.target.value);
  };

  // Funkcija za submit ID-a korisnika
  const handleSubmit = (e) => {
    e.preventDefault();  // Spriječavamo defaultno ponašanje forme
    setMessages([]);
    setCurrentConversation(null);
    setSelectedUserId(tempUserId);  // Postavljamo selectedUserId na osnovu tempUserId
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <p>Unesite ID korisnika</p>
        <input  className="p-2 border rounded mx-2"
          type="number"
          value={tempUserId}
          onChange={handleUserIdChange}
          placeholder="0"
        />
        <button type="submit" className='btn btn-primary'>Potvrdi</button>
      </form>

      <section id="work-section" className="hero d-flex section-bg-w p-4 admin-chat-section">
        <div className="container">
          <div className="row justify-content-center gy-5">
            <div className="chat-bottom-mg col-lg-8 d-flex flex-column justify-content-center text-center">
              <div className="chat-container">
                <div className="chat-sidebar">
                  <h2>Korisnici</h2>
                  <ul>
                    {users.map(user => (
                      <li
                        key={user.id_korisnika}
                        className={currentConversation?.id_korisnika === user.id_korisnika ? 'active' : ''}
                        onClick={() => handleUserClick(user)}
                      >
                        {user.ime}
                        {/* Prikaz broja nepročitanih poruka za svakog korisnika */}
                        {notifications[user.id_korisnika] > 0 && (
                          <span className="notification-badge">{notifications[user.id_korisnika]}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="chat-main">
                  {currentConversation ? (
                    <>
                      <div className="chat-messages" ref={chatBoxRef}>
                        {messages.map((msg, index) => {
                          const isSentBySelectedUser = Number(msg.sender_id) === Number(selectedUserId);

                          return (
                            <div
                              key={index}
                              className={isSentBySelectedUser ? 'message sent' : 'message received'}
                            >
                              <p>{msg.message_text}</p>
                              <small>{formatDate(msg.created_at)}</small>
                              {isSentBySelectedUser && index === messages.length - 1 && (
                                <div className="seen-status">
                                  {msg.seen === 'D' ? 'Seen' : 'Delivered'}
                                </div>
                              )}
                            </div>
                          );
                        })}
                        <div ref={messagesEndRef} />
                      </div>
                    </>
                  ) : (
                    <h2 className="no-conversation">Izaberite korisnika</h2>
                  )}
                </div>
              </div>   
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminChat;